import * as api from '../../api';
import * as settings from '../../settings';

export const trackAdThirdParty = (page, eventId, trackUrl) => (
  dispatch,
  getState
) => {
  trackAd(page, eventId, trackUrl, dispatch);
};

export const trackAdInternal = (page, eventId, campaign, elementId) => (
  dispatch,
  getState
) => {
  const trackUrl = api.createTrackingUrl(page, eventId, campaign, elementId);
  trackAd(page, eventId, trackUrl, dispatch);
};

export const loadAdSlot = adUnitPath => dispatch => {
  dispatch({
    type: 'AD_SLOT_LOAD',
    adUnitPath,
  });
};

export const renderAdSlot = adUnitPath => dispatch => {
  dispatch({
    type: 'AD_SLOT_RENDERED',
    adUnitPath,
  });
};

export const destroyAdSlot = adUnitPath => dispatch => {
  dispatch({
    type: 'AD_SLOT_DESTROYED',
    adUnitPath,
  });
};

export const incrementVideoPlayerId = () => dispatch => {
  dispatch({
    type: 'NEW_VIDEO_PLAYER_ID',
  });
};

const trackAd = (page, eventId, trackUrl, dispatch) => {
  if (!window || !window.location.hostname.match('funbrain.com')) {
    dispatch({
      type: 'AD_TRACK_REQUEST_CANCELLED',
      page,
      eventId,
      trackUrl,
    });
    if (settings.IS_STAGING)
      console.log('We would have called this tracking URL:', trackUrl);
    return Promise.resolve();
  }

  dispatch({
    type: 'AD_TRACK_REQUEST',
    page,
  });

  return api.trackAd(trackUrl).then(
    response => {
      dispatch({
        type: eventId,
        page,
        response,
      });
    },
    error => {
      if (typeof Raven !== 'undefined') Raven.captureException(error);
      let errorObj = error.error ? error.error : { message: 'Unknown Error' };
      dispatch({
        type: 'AD_TRACK_FAILURE',
        page,
        eventId,
        error: errorObj,
        message: errorObj.message,
      });
    }
  );
};
